module.exports = __webpack_public_path__ + "images/emoji/boar.cbd21778c31caab493be.png";